import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, ColumnLayout, Form, Link, Modal, Multiselect, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';


interface ItemRouting {
  idRouting: number;
  routing: string;
  label: string;
  value: string;
}
interface MenuItem {
  idMenu: number;
  text: string;
  items?: MenuItem[];
  type?: string;
  href?: string;
  section?: string;
  jsonRouting: number[];
}

export const SystemRoutingAssignPage = () => {
  const { menu } = useGlobalState();




  const [oMenu, setOMenu] = useState<MenuItem>();
  const [menus, setMenus] = useState<MenuItem[]>([]);
  const [routings, setRoutings] = useState<ItemRouting[]>([]);
  const [selectedRoutings, setSelectedRoutings] = useState<ItemRouting[]>([]);


  const handleGetAll = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/system/routing/all',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({})
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.menus) {
        setMenus(data.menus)
        setRoutings(data.routings)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }


  const handleSave = async () => {
    const menuToSave = {
      ...oMenu!,
      jsonRouting: selectedRoutings.map(r => r.idRouting),
    };

    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/system/routing/savemenu',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify(menuToSave)
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.menus) {
        setMenus(data.menus)
        setRoutings(data.routings)
        setOMenu(undefined);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    handleGetAll()
  }, []);

  const renderMenu = (items: MenuItem[], parentId: number | null = null): JSX.Element => (
    <ul style={{ listStyle: "none", paddingLeft: "1em" }}>
      {items.map((item: MenuItem) => (
        <li key={item.idMenu}>
          {item.href ? (
            <div
              style={{ textDecoration: "none", color: "#000" }}>

              <Link variant="secondary"
                onClick={(e) => {
                  setSelectedRoutings(item.jsonRouting.map(id => routings.find(r => r.idRouting === id)).filter(Boolean) as ItemRouting[])
                  setOMenu(item)

                  //console.log(item)
                }}>
                {item.text}</Link> {item.jsonRouting.length > 0 ? `(${item.jsonRouting.length})` : null}
            </div>
          ) : (
            <span>{item.text}</span>
          )}

          {/* recursive call if the item has children */}
          {item.items && item.items.length > 0 && renderMenu(item.items, item.idMenu)}
        </li>
      ))}
    </ul>
  );
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Asignación de enrutamiento</Header>
          <ColumnLayout columns={2}>
            <div>
              {renderMenu(menus)}
            </div>
            <div>
              {oMenu && (
                <>

                </>
              )}
            </div>
          </ColumnLayout>
          <Modal size="large" visible={oMenu !== undefined} onDismiss={() => setOMenu(undefined)} header={`Enrutamiento de ${oMenu?.text} #${oMenu?.idMenu}`} >
            <Form header={
              <Header variant="h2">Enrutamiento de {oMenu?.text}</Header>}
              actions={<Button variant="primary" onClick={() => {
                handleSave()

              }}>Guardar cambios</Button>}>

              <Multiselect
                selectedOptions={selectedRoutings}
                filteringType="auto"
                onChange={({ detail }) =>
                  setSelectedRoutings(detail.selectedOptions as ItemRouting[])

                }
                options={routings}
                placeholder="Choose options"
              />
            </Form>
          </Modal>
        </SpaceBetween>
      }
    />
  );
};
